export default "__VITE_ASSET__DSDbFcDi__"